/* eslint-disable */
import { AES, enc, mode, pad } from 'crypto-js'
import emoji from '@/const/emoji.js'
import moment from 'moment'

/** 加密密钥 - 初始化 */
const ENCODE_KEY = 'clould~hui~zhan~'

/**
 *加密处理
 */
export const encryption = (word) => {
  const srcs = enc.Utf8.parse(word)
  const encrypted = AES.encrypt(srcs, enc.Utf8.parse(ENCODE_KEY), {
    iv: enc.Utf8.parse(ENCODE_KEY),
    mode: mode.CBC,
    padding: pad.ZeroPadding,
  })
  return encrypted.toString()
}

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

/**
 * 获取浏览器版本信息
 */
export function getBrowserInfo() {
  const getBrowser = () => {
    const agent = navigator.userAgent.toLowerCase()
    const arr = []
    const system = agent.split(' ')[1].split(' ')[0].split('(')[1]
    arr.push(system)
    const REGSTR_EDGE = /edge\/[\d.]+/gi
    const REGSTR_IE = /trident\/[\d.]+/gi
    const OLD_IE = /msie\s[\d.]+/gi
    const REGSTR_FF = /firefox\/[\d.]+/gi
    const REGSTR_CHROME = /chrome\/[\d.]+/gi
    const REGSTR_SAF = /safari\/[\d.]+/gi
    const REGSTR_OPERA = /opr\/[\d.]+/gi
    // IE
    if (agent.indexOf('trident') > 0) {
      arr.push(agent.match(REGSTR_IE)[0].split('/')[0])
      arr.push(agent.match(REGSTR_IE)[0].split('/')[1])
      return arr
    }
    // OLD_IE
    if (agent.indexOf('msie') > 0) {
      arr.push(agent.match(OLD_IE)[0].split(' ')[0])
      arr.push(agent.match(OLD_IE)[0].split(' ')[1])
      return arr
    }
    // Edge
    if (agent.indexOf('edge') > 0) {
      arr.push(agent.match(REGSTR_EDGE)[0].split('/')[0])
      arr.push(agent.match(REGSTR_EDGE)[0].split('/')[1])
      return arr
    }
    // firefox
    if (agent.indexOf('firefox') > 0) {
      arr.push(agent.match(REGSTR_FF)[0].split('/')[0])
      arr.push(agent.match(REGSTR_FF)[0].split('/')[1])
      return arr
    }
    // Opera
    if (agent.indexOf('opr') > 0) {
      arr.push(agent.match(REGSTR_OPERA)[0].split('/')[0])
      arr.push(agent.match(REGSTR_OPERA)[0].split('/')[1])
      return arr
    }
    // Safari
    if (agent.indexOf('safari') > 0 && !agent.includes('chrome')) {
      arr.push(agent.match(REGSTR_SAF)[0].split('/')[0])
      arr.push(agent.match(REGSTR_SAF)[0].split('/')[1])
      return arr
    }
    // Chrome
    if (agent.indexOf('chrome') > 0) {
      arr.push(agent.match(REGSTR_CHROME)[0].split('/')[0])
      arr.push(agent.match(REGSTR_CHROME)[0].split('/')[1])
      return arr
    } else {
      arr.push('未获取到浏览器信息')
      return arr
    }
  }
  let message = ''
  const browserInfo = getBrowser()
  if (browserInfo[1] && browserInfo[2]) {
    message = getBrowser()[1] + ' ' + getBrowser()[2]
  } else {
    message = 'pc'
  }
  switch (message) {
    case 'msie 6.0':
      message = 'Internet Explorer 6'
      break
    case 'msie 7.0':
      message = 'Internet Explorer 7'
      break
    case 'trident 4.0':
      message = 'Internet Explorer 8'
      break
    case 'trident 5.0':
      message = 'Internet Explorer 9'
      break
    case 'trident 6.0':
      message = 'Internet Explorer 10'
      break
    case 'trident 7.0':
      message = 'Internet Explorer 11'
      break
  }
  return message
}

/**
 * 根据url获取语言环境
 */
export function getLocale() {
  if (process.client) {
    if (window.location.hostname.includes('en')) {
      return 'en'
    } else if (window.location.hostname.includes('localhost')) {
      return false
    }
    return 'zh'
  }
}

/*
获取本机IP
*/
// const os = require('os')
// export function getIPAdress() {
//   const interfaces = os.networkInterfaces()
//   for (const devName in interfaces) {
//     const iface = interfaces[devName]
//     for (let i = 0; i < iface.length; i++) {
//       const alias = iface[i]
//       if (
//         alias.family === 'IPv4' &&
//         alias.address !== '127.0.0.1' &&
//         !alias.internal
//       ) {
//         return alias.address
//       }
//     }
//   }
// }
/**
 * 获取客户端IP地址
 */
// export function getYourIP() {
//   const RTCPeerConnection =
//     window.RTCPeerConnection ||
//     window.webkitRTCPeerConnection ||
//     window.mozRTCPeerConnection
//   if (RTCPeerConnection)
//     (function() {
//       const rtc = new RTCPeerConnection({
//         iceServers: []
//       })
//       if (1 || window.mozRTCPeerConnection) {
//         rtc.createDataChannel('', {
//           reliable: false
//         })
//       }

//       rtc.onicecandidate = function(evt) {
//         if (evt.candidate) grepSDP('a=' + evt.candidate.candidate)
//       }
//       rtc.createOffer(
//         function(offerDesc) {
//           grepSDP(offerDesc.sdp)
//           rtc.setLocalDescription(offerDesc)
//         },
//         function(e) {
//           console.warn('offer failed', e)
//         }
//       )

//       const addrs = Object.create(null)
//       addrs['0.0.0.0'] = false

//       function updateDisplay(newAddr) {
//         if (newAddr in addrs) return
//         else addrs[newAddr] = true
//         const displayAddrs = Object.keys(addrs).filter(function(k) {
//           return addrs[k]
//         })
//         for (let i = 0; i < displayAddrs.length; i++) {
//           if (displayAddrs[i].length > 16) {
//             displayAddrs.splice(i, 1)
//             i--
//           }
//         }
//         document.getElementById('list').textContent = displayAddrs[0]
//       }

//       function grepSDP(sdp) {
//         const hosts = []
//         sdp.split('\r\n').forEach(function(line, index, arr) {
//           if (~line.indexOf('a=candidate')) {
//             var parts = line.split(' ')
//             var addr = parts[4]
//             const type = parts[7]
//             if (type === 'host') updateDisplay(addr)
//           } else if (~line.indexOf('c=')) {
//             var parts = line.split(' ')
//             var addr = parts[2]
//             updateDisplay(addr)
//           }
//         })
//       }
//     })()
//   else {
//     return 'not'
//     // document.getElementById('list').textContent = "请使用主流浏览器：chrome,firefox,opera,safari";
//   }
// }
/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    (event) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false,
  )
}

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.includes(s)
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

// /**
//  * @description 防抖 传参有问题,替换了import debounce from 'lodash/debounce'
//  * @param {Function}  callback
//  * @param {Number}  时间间隔 默认500ms
//  * @param {Boolean}  是否立即开始
//  * @example
//  * @return {Function}
//  */
// export function debounce(func, wait = 500, immediate) {
//   let timeout, args, context, timestamp, result

//   const later = function() {
//     // 据上一次触发时间间隔
//     const last = +new Date() - timestamp

//     // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
//     if (last < wait && last > 0) {
//       timeout = setTimeout(later, wait - last)
//     } else {
//       timeout = null
//       // 如果设定为immediate===true,因为开始边界已经调用过了此处无需调用
//       if (!immediate) {
//         result = func.apply(context, args)
//         if (!timeout) context = args = null
//       }
//     }
//   }
//   return function(...args) {
//     context = this
//     timestamp = +new Date()
//     const callNow = immediate && !timeout
//     // 如果延时不存在,重新设定延时
//     if (!timeout) timeout = setTimeout(later, wait)
//     if (callNow) {
//       console.log('args', context, args)
//       result = func.apply(context, args)
//       context = args = null
//     }
//     console.log('res', result)
//     return result
//   }
// }

/**
 * @description 节流函数
 * @example
 * @return {Function}
 * @param fn
 * @param delay
 */
export function throttle(fn, delay = 500) {
  let now, lastExec, timer, context, args

  const execute = function () {
    fn.apply(context, args)
    lastExec = now
  }

  return function () {
    context = this
    args = arguments

    now = Date.now()

    if (timer) {
      clearTimeout(timer)
      timer = null
    }

    if (lastExec) {
      const diff = delay - (now - lastExec)
      if (diff < 0) {
        execute()
      } else {
        timer = setTimeout(() => {
          execute()
        }, diff)
      }
    } else {
      execute()
    }
  }
}

/**
 * @description: 睡眠函数
 * @param time 等待时间, 默认500毫秒
 */
export function sleep(time = 500) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

/**
 * @description: 深层拷贝
 * @example
 * @param source 对象
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  if (source) {
    Object.keys(source).forEach((keys) => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
  }

  return targetObj
}

/**
 * @description:扁平化数组
 * @param {Array} 多维数组
 * @return {Array} 一维数组
 */
export function flatArray(data, expandAll, parent = null, level = null) {
  let tmp = []
  data.forEach((record, i) => {
    record._expanded = record._expanded === undefined ? expandAll : true
    if (level !== undefined && level !== null) {
      record.level = level !== undefined && level !== null ? level + 1 : 0
    }
    record.sort = i
    if (parent) {
      record.path = `/${parent.id}/${record.id}`
      record.parentId = parent.id
    } else {
      record.parent = ''
      record.parentId = 0
      record.path = `/${record.id}`
    }
    tmp.push(record)
    if (record.children && record.children.length > 0) {
      const children = flatArray(record.children, expandAll, record, record.level)
      tmp = tmp.concat(children)
    }
  })
  return tmp
}

/**
 * @description 一维数组格式转化为tree格式
 * @param {Array}  一维数组
 * @return {Array} 多维数组
 */
export function arrayToTree(treeArray) {
  const r = []
  const tmpMap = {}

  for (let i = 0, l = treeArray.length; i < l; i++) {
    // 以每条数据的id作为obj的key值,数据作为value值存入到一个临时对象里面
    tmpMap[treeArray[i].id] = treeArray[i]
  }

  for (let i = 0, l = treeArray.length; i < l; i++) {
    const key = tmpMap[treeArray[i].parentId]

    // 循环每一条数据的pid,假如这个临时对象有这个key值,就代表这个key对应的数据有children,需要Push进去
    if (key) {
      if (!key.children) {
        key.children = []
        key.children.push(treeArray[i])
      } else {
        key.children.push(treeArray[i])
      }
    } else {
      // 如果没有这个Key值,那就代表没有父级,直接放在最外层
      r.push(treeArray[i])
    }
  }
  return r
}

/**
 * @description: 递归获得所有层级
 */
export function getAllLevel(id, array = []) {
  const result = []
  const element = array.find((item) => item.id === id) || {}
  result.unshift(element)
  if (element.parentId) {
    result.unshift(...getAllLevel(element.parentId, array))
  }
  return result
}

/**
 * @description 判断两个对象是否相等,这两个对象的值只能是数字或字符串
 * @param {Object}  对象
 * @param {Object}  对象
 */
export function objEqual(obj1, obj2) {
  const keysArr1 = Object.keys(obj1)
  const keysArr2 = Object.keys(obj2)
  if (keysArr1.length !== keysArr2.length) return false
  if (keysArr1.length === 0 && keysArr2.length === 0) return true
  return !keysArr1.some((key) => obj1[key] !== obj2[key])
}

/**
 * @description:获取数组集(传入数组ID)
 * @param {Array} 数组1
 * @param {Array} 数组2
 * @param {Boolean} true / false
 * @return {Array} isIntersection = true 返回数组差集 / false 返回数组交集
 */

export function difference(arr1, arr2, isIntersection = false) {
  const val = new Set(arr2)
  return [...arr1.filter((v) => (isIntersection ? !val.has(v) : val.has(v)))]
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp(`(\\s|^)${cls}(\\s|$)`))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ` ${cls}`
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp(`(\\s|^)${cls}(\\s|$)`)
    ele.className = ele.className.replace(reg, ' ')
  }
}

/**
 * 把目标url转换为绝对url,
 * @param target
 */
export function transformOutsideLink(target) {
  const urlPattern = /^https?:\/\//i

  if (urlPattern.test(target)) {
    return target
  } else if (target.includes('www')) {
    return `http://${target}`
  }

  // 以相对路径替换原url
  const pathnameArr = location?.pathname?.split('/')
  let preUrl = location?.origin
  for (let i = 0; i < pathnameArr.length - 1; i++) {
    if (pathnameArr[i].includes('.html')) {
      break
    } else {
      preUrl = `${preUrl}/${pathnameArr[i]}`
    }
  }
  return `${preUrl}${target}`
}

/**
 * 验证表单时 如果不通过验证滚动到不通过验证的控件位置
 * @param obj validate((valid, object) 验证不通过的对象
 */
export function focusFormControls(ref, obj) {
  for (const i in obj) {
    let dom = ref[i]
    if (!dom) return
    if (Object.prototype.toString.call(dom) !== '[object Object]') {
      // 这里是针对遍历的情况（多个输入框）,取值为数组
      dom = dom[0]
    }
    dom.$el.scrollIntoView({
      // 滚动到指定节点
      block: 'center', // 值有start,center,end,nearest,当前显示在视图区域中间
      behavior: 'smooth', // 值有auto、instant,smooth,缓动动画（当前是慢速的）
    })
    break
  }
}

/**
 * 验证表单时 如果不通过验证滚动到不通过验证的控件位置
 * @param {*} dom ref,具体元素VueComponent
 * @param {*} block 位置 start,center,end,nearest,（默认在视图区域中间）
 * @param {*} behavior 动画 auto、instant,smooth,缓动动画（默认慢速）
 */
export function focusElementPosition(dom, block = 'center', behavior = 'smooth') {
  console.log(dom, dom.$el, block, behavior)
  dom.$el.scrollIntoView({
    // 滚动到指定节点
    block,
    behavior,
  })
}

/**
 * 检查图片的分辨率
 * @param {*} curFile 文件
 * @param {*} width 宽 默认0
 * @param {*} height 高 默认0
 * @param {*} operator 操作符 默认'='等于 '>='大于等于  '<='小于等于
 * @returns result.verify = 0检查成功不符合分辨率 1检查成功 -1检查错误
 */
export function checkImageWH(curFile, width = 0, height = 0, operator = '=') {
  const result = {
    verify: 1,
    width: 0,
    height: 0,
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = function (event) {
      const myImage = new Image()
      myImage.src = event.target.result
      myImage.onload = function () {
        let flag = 0
        let condition = false
        switch (operator) {
          case '=':
            condition = myImage.width === width && myImage.height === height
            break
          case '>=':
            condition = myImage.width >= width && myImage.height >= height
            break
          case '<=':
            condition = myImage.width <= width && myImage.height <= height
            break
          default:
            break
        }
        if (condition) {
          flag = 1
        }
        result.verify = flag
        result.width = myImage.width
        result.height = myImage.height
        return resolve(result)
      }
      myImage.onerror = function () {
        result.verify = -1
        return reject(result)
      }
    }
    reader.readAsDataURL(curFile)
  })
}

/**
 * 检查图片的分辨率是否等比例
 * @param {*} curFile 文件
 * @returns resolve检查成功 reject检查错误
 */
export function checkImageEqualPercentage(curFile) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = function (event) {
      const myImage = new Image()
      myImage.src = event.target.result
      myImage.onload = function () {
        if (myImage.width === myImage.height) {
          return resolve(1)
        } else {
          return resolve(0)
        }
      }
      myImage.onerror = function () {
        return reject(-1)
      }
    }
    reader.readAsDataURL(curFile)
  })
}

/**
 * 生成uuid方法
 * @returns {string}
 */
export const createUUID = function () {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = ((d + Math.random() * 16) % 16) | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return uuid
}

// /**
//  * 深拷贝
//  * @param {*} obj 拷贝对象(object or array)
//  * @param {*} cache 缓存数组
//  */
// export const deepClone = function (obj, cache = []) {
//   // typeof [] => 'object'
//   // typeof {} => 'object'
//   if (obj === null || typeof obj !== 'object') {
//     return obj
//   }
//   // 如果传入的对象与缓存的相等, 则递归结束, 这样防止循环
//   /**
//    * 类似下面这种
//    * var a = {b:1}
//    * a.c = a
//    * 资料: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
//    */
//   const hit = cache.filter(c => c.original === obj)[0]
//   if (hit) {
//     return hit.copy
//   }

//   const copy = Array.isArray(obj) ? [] : {}
//   // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
//   cache.push({
//     original: obj,
//     copy
//   })
//   Object.keys(obj).forEach(key => {
//     copy[key] = deepClone(obj[key], cache)
//   })

//   return copy
// }

export const deepCompare = function (x, y) {
  let i, l, leftChain, rightChain

  function compare2Objects(x, y) {
    let p

    // remember that NaN === NaN returns false
    // and isNaN(undefined) returns true
    if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
      return true
    }

    // Compare primitives and functions.
    // Check if both arguments link to the same object.
    // Especially useful on the step where we compare prototypes
    if (x === y) {
      return true
    }

    // Works in case when functions are created in constructor.
    // Comparing dates is a common scenario. Another built-ins?
    // We can even handle functions passed across iframes
    if (
      (typeof x === 'function' && typeof y === 'function') ||
      (x instanceof Date && y instanceof Date) ||
      (x instanceof RegExp && y instanceof RegExp) ||
      (x instanceof String && y instanceof String) ||
      (x instanceof Number && y instanceof Number)
    ) {
      return x.toString() === y.toString()
    }

    // At last checking prototypes as good as we can
    if (!(x instanceof Object && y instanceof Object)) {
      return false
    }

    if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
      return false
    }

    if (x.constructor !== y.constructor) {
      return false
    }

    if (x.prototype !== y.prototype) {
      return false
    }

    // Check for infinitive linking loops
    if (leftChain.includes(x) || rightChain.includes(y)) {
      return false
    }

    // Quick checking of one object being a subset of another.
    // todo: cache the structure of arguments[0] for performance
    for (p in y) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false
      } else if (typeof y[p] !== typeof x[p]) {
        return false
      }
    }

    for (p in x) {
      if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
        return false
      } else if (typeof y[p] !== typeof x[p]) {
        return false
      }

      switch (typeof x[p]) {
        case 'object':
        case 'function':
          leftChain.push(x)
          rightChain.push(y)

          if (!compare2Objects(x[p], y[p])) {
            return false
          }

          leftChain.pop()
          rightChain.pop()
          break

        default:
          if (x[p] !== y[p]) {
            return false
          }
          break
      }
    }

    return true
  }

  if (arguments.length < 1) {
    return true // Die silently? Don't know how to handle such case, please help...
    // throw "Need two or more arguments to compare";
  }

  for (i = 1, l = arguments.length; i < l; i++) {
    leftChain = [] // Todo: this can be cached
    rightChain = []

    if (!compare2Objects(arguments[0], arguments[i])) {
      return false
    }
  }

  return true
}
/**
 * 把内容复制到剪贴板
 * @param {*} text 内容
 * @param {Object} message 提示框方法 this.$message
 */
export const copyTextToClipboard = (text, message) => {
  function handler(event) {
    console.log('copy', event)
    event.clipboardData.setData('text/plain', text)
    event.preventDefault()
  }

  document.addEventListener('copy', handler) // 增加copy监听
  document.execCommand('copy') // 执行copy命令触发监听
  document.removeEventListener('copy', handler) // 移除copy监听,不产生影响

  if (message) {
    message.success('复制成功')
  }
}

/**
 * @description: 复制图片到剪贴板
 * @param {*} ref 准备复制的图片节点
 * @return {*}
 */
export const copyImgToClipboard = (ref, message) => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const img = new Image()
  canvas.width = ref.width
  canvas.height = ref.height
  img.crossOrigin = 'Anonymous'
  img.src = ref.src
  img.onload = () => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
    ctx.drawImage(img, 0, 0) // 将canvas转为blob
    canvas.toBlob(async (blob) => {
      console.log(blob)
      const data = [new ClipboardItem({ [blob.type]: blob })] // https://w3c.github.io/clipboard-apis/#dom-clipboard-write
      await navigator.clipboard.write(data).then(
        () => {
          if (message) {
            message.success('复制成功')
          }
        },
        () => {
          console.error('Unable to write to clipboard.')
        },
      )
    })
  }
}

// 根据角色id返回对应路径
export const goRoleConsole = function (roleId) {
  if (!roleId) {
    return ''
  }
  let url = ''
  switch (roleId) {
    case 1:
      url = '/visitor'
      break
    case 2:
      url = '/organizer'
      break
    case 3:
      url = '/exhibitor'
      break
    case 4:
      url = '/contractors'
      break
    case 5:
      url = '/designer'
      break
    default:
      url = '/'
      break
  }
  return url
}

/**
 * 检测是否到登录页, 但是弹窗出现
 */
export const regularToLogin = (name, that) => {
  if (
    window.location.pathname.includes('/cloudexhibition/') ||
    window.location.pathname.includes('/product/') ||
    (that.$route.matched[0] && that.$route.matched[0].path === '/:id')
  ) {
    that.$store.commit('switchPopupLoginStatus', name || 'login')
    return false
  } else {
    return true
  }
}

/**
 * form表单校验部分信息, 一般是中英文使用
 * @param {Object} form 所校验的表单
 * @param {Array} validateVal 准备校验的值
 * @param {Function} cb 返回的值
 * @param {Boolean} setFocus 是否返回错误的地方
 */
export const checkPart = async (ref, form, validateVal, setFocus = true) => {
  const results = await Promise.all(
    validateVal.map((item) => {
      const p = new Promise(function (resolve, reject) {
        form &&
          form.validateField(item, (error, object) => {
            console.log('form表单校验部分信息 validateField', item, error, object)

            // 如果有报错信息, 提示报错, 并跳到对应位置
            if (error) {
              console.error('error submit!!', object)
              setFocus && focusFormControls(ref, object)
              resolve(error)
            } else {
              resolve('')
            }
          })
      })
      return p
    }),
  )
  // data 里是各个字段的验证错误信息, 如果为空串则认为验证通过, 如果数组里全为空串则所有验证通过
  // 判断data 里是否全是空串

  console.log('results', results)

  const errData =
    results && results.length > 0
      ? results.filter((item) => {
          return item.length > 0
        })
      : results

  console.log('checkPart_results', results, errData)

  return errData
}

/**
 * @description: 编辑信息样式, 主要是处理表情符号和url链接
 * @param {*} txt 文本
 * @param {*} linkColor 链接颜色
 * @return {*}
 */
export const formatTxt = (txt = '', linkColor = '#fff') => {
  // 是否为url链接
  const reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
  const regex = /(\[.*?\])/g

  const rnTxt = []
  let match = null
  let start = 0
  let index = 0
  if (!txt) {
    return ''
  }
  while ((match = regex.exec(txt))) {
    index = match.index
    if (index > start) {
      rnTxt.push(txt.substring(start, index))
    }
    if (match[1] in emoji.obj) {
      const v = emoji.obj[match[1]]
      rnTxt.push(`<img src="https://oss-resource668.yzdli.com/website/image/faces/${v}" style="width:30px"/>`)
    } else {
      rnTxt.push(match[1])
    }
    start = index + match[1].length
  }
  rnTxt.push(txt.substring(start, txt.length))

  return rnTxt.join('').replace(reg, (matched, p1, p2) => {
    if (matched.includes('aliyuncs.com/website/image/faces') || matched.includes('yzdli.com/website/image/faces')) {
      return matched
    } else {
      return ` <a target='_blank' style='color:${linkColor};text-decoration: underline;' href='${p1}${p2}'>${p1}${p2}</a> `
    }
  })
}

export function getRandomItem(array) {
  let index = Math.floor(Math.random() * array.length)
  return array[index]
}

export function generateMixed(n) {
  const chars = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ]
  let res = ''
  for (let i = 0; i < n; i++) {
    const id = Math.floor(Math.random() * 36)
    res += chars[id]
  }
  return res
}

export function currencyUnit(num, lang) {
  if (lang === 'en') {
    return unitConversionEn(num)
  } else {
    return unitConversionZh(num)
  }
}

function unitConversionZh(num) {
  const point = 2
  if (!num) {
    return ''
  }
  const numStr = num.toString().split('.')[0]
  if (numStr.length < 6) {
    return numStr
  } else if (numStr.length >= 6 && numStr.length <= 8) {
    const decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
    return parseFloat(parseInt(num / 10000) + '.' + decimal) + '万'
  } else if (numStr.length > 8) {
    const decimal = numStr.substring(numStr.length - 8, numStr.length - 8 + point)
    return parseFloat(parseInt(num / 100000000) + '.' + decimal) + '亿'
  }
}

function unitConversionEn(num, digits = 2) {
  const si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  let i
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
}

// 文本复制
export function copyText(str) {
  const el = document.createElement('textarea')
  el.value = str
  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  el.style.top = '-9999px'
  document.body.appendChild(el)
  const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
  if (selected) {
    document.getSelection().removeAllRanges()
    document.getSelection().addRange(selected)
  }
}

// 数字千分位分割
export function commafy(num) {
  return num.toString().includes('.') ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

// 数组分组
export function arrayGroup(array, subGroupLength) {
  let index = 0
  const newArray = []

  while (index < array.length) {
    newArray.push(array.slice(index, (index += subGroupLength)))
  }

  return newArray
}

/**
 * @description: 增加空白框, 使行整洁
 * @param {*} list 列表
 * @param {*} span  每行的列数
 * @return {*}
 */
export function tidyRow(list, span = 5) {
  const data = list
  if (data.length > 0) {
    let num = data.length % span
    if (num !== 0) {
      num = span - num
      for (let i = 0; i < num; i++) {
        data.push({
          type: 'isEmpty',
        })
      }
    }
  }

  return data
}

/**
 * @description: 对象数组去重合并
 * @param {*} arrayList 数组列表
 * @param {*} key 唯一参照key
 * @return {*}
 */
export function objectsArraysDeDuplicationMerge(arrayList, key = 'id') {
  const mergeArray = []
  const isHasId = []

  if (arrayList && arrayList.length) {
    arrayList.forEach((oneArray) => {
      if (oneArray && oneArray.length) {
        oneArray.forEach((data) => {
          if (!isHasId.includes(data[key])) {
            mergeArray.push(data)
            isHasId.push(data[key])
          }
        })
      }
    })
  }
  console.log('mergeArray', mergeArray)

  return mergeArray
}

/**
 * @description: 对象列表字段与key反转
 * @param {*} object 对象
 * @param {*} inversionKey 需要反转的属性key
 * @return {*}
 */
export function objectFieldKeyInversion(object, inversionKey) {
  const newObject = {}
  Object.keys(object).forEach((key) => {
    newObject[object[key][inversionKey]] = { ...object[key], [inversionKey]: key }
  })
  return newObject
}

/**
 * @description: 对象value与key反转
 * @param {*} object 对象
 * @return {*}
 */
export function objectFieldKeyValue(object) {
  const newObject = {}
  Object.keys(object).forEach((key) => {
    newObject[object[key]] = key
  })
  return newObject
}

export function unique(arr, key) {
  if (!arr) return arr
  if (key === undefined) return [...new Set(arr)]
  const map = {
    string: (e) => e[key],
    function: (e) => key(e),
  }
  const fn = map[typeof key]
  const obj = arr.reduce((o, e) => ((o[fn(e)] = e), o), {})
  return Object.values(obj)
}

/**
 * 获取全球展览举办日期, 包括今年,明年和后年
 */
export function getExhibitionThreeYear() {
  const pastFutureFiveYears = []
  // 生成月
  const month = []
  for (let i = 0; i < 12; i++) {
    const num = i
    const monthMoment = moment().month(i).format('Mo')
    month.push({
      label: `${monthMoment}`,
      value: num + 1,
    })
  }
  console.log('month', month)
  // 生成年月
  for (let i = 0; i < 3; i++) {
    const year = moment().add(i, 'Y').format('YYYY')

    pastFutureFiveYears.push({
      label: `${year}`,
      value: year,
      children: month,
    })
  }
  return pastFutureFiveYears
}

/**
 * 压缩图片方法
 * @param {file} file 文件
 * @param {Number} quality 图片质量(取值0-1之间默认0.92)
 */
export function compressImg(file, quality) {
  var qualitys = 0.52
  console.log(parseInt((file.size / 1024).toFixed(2)))
  if (parseInt((file.size / 1024).toFixed(2)) < 1024) {
    qualitys = 0.85
  }
  if (5 * 1024 < parseInt((file.size / 1024).toFixed(2))) {
    qualitys = 0.92
  }
  if (quality) {
    qualitys = quality
  }
  if (file[0]) {
    return Promise.all(Array.from(file).map((e) => this.compressImg(e, qualitys))) // 如果是 file 数组返回 Promise 数组
  } else {
    return new Promise((resolve) => {
      console.log(file)
      if ((file.size / 1024).toFixed(2) < 300) {
        resolve({
          file: file,
        })
      } else {
        const reader = new FileReader() // 创建 FileReader
        reader.onload = ({ target: { result: src } }) => {
          const image = new Image() // 创建 img 元素
          image.onload = async () => {
            const canvas = document.createElement('canvas') // 创建 canvas 元素
            const context = canvas.getContext('2d')
            var targetWidth = image.width
            var targetHeight = image.height
            var originWidth = image.width
            var originHeight = image.height
            if (
              1 * 1024 <= parseInt((file.size / 1024).toFixed(2)) &&
              parseInt((file.size / 1024).toFixed(2)) <= 10 * 1024
            ) {
              var maxWidth = 1600
              var maxHeight = 1600
              targetWidth = originWidth
              targetHeight = originHeight
              // 图片尺寸超过的限制
              if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                  // 更宽，按照宽度限定尺寸
                  targetWidth = maxWidth
                  targetHeight = Math.round(maxWidth * (originHeight / originWidth))
                } else {
                  targetHeight = maxHeight
                  targetWidth = Math.round(maxHeight * (originWidth / originHeight))
                }
              }
            }
            if (
              10 * 1024 <= parseInt((file.size / 1024).toFixed(2)) &&
              parseInt((file.size / 1024).toFixed(2)) <= 20 * 1024
            ) {
              maxWidth = 1400
              maxHeight = 1400
              targetWidth = originWidth
              targetHeight = originHeight
              // 图片尺寸超过的限制
              if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                  // 更宽，按照宽度限定尺寸
                  targetWidth = maxWidth
                  targetHeight = Math.round(maxWidth * (originHeight / originWidth))
                } else {
                  targetHeight = maxHeight
                  targetWidth = Math.round(maxHeight * (originWidth / originHeight))
                }
              }
            }
            canvas.width = targetWidth
            canvas.height = targetHeight
            context.clearRect(0, 0, targetWidth, targetHeight)
            context.drawImage(image, 0, 0, targetWidth, targetHeight) // 绘制 canvas
            const canvasURL = canvas.toDataURL('image/jpeg', qualitys)
            const buffer = atob(canvasURL.split(',')[1])
            let length = buffer.length
            const bufferArray = new Uint8Array(new ArrayBuffer(length))
            while (length--) {
              bufferArray[length] = buffer.charCodeAt(length)
            }
            const miniFile = new File([bufferArray], file.name, {
              type: 'image/jpeg',
            })
            console.log({
              file: miniFile,
              origin: file,
              beforeSrc: src,
              afterSrc: canvasURL,
              beforeKB: Number((file.size / 1024).toFixed(2)),
              afterKB: Number((miniFile.size / 1024).toFixed(2)),
              qualitys: qualitys,
            })
            resolve({
              file: miniFile,
              origin: file,
              beforeSrc: src,
              afterSrc: canvasURL,
              beforeKB: Number((file.size / 1024).toFixed(2)),
              afterKB: Number((miniFile.size / 1024).toFixed(2)),
            })
          }
          image.src = src
        }
        reader.readAsDataURL(file)
      }
    })
  }
}
